<template>
  <router-link
    v-if="routerLink"
    :to="getLinkBuilder(item)"
    class="LKMunMehForm__content__link"
  >
    <LKMunMehFormRow :idx="idx" :item="item" :bold="bold" />
  </router-link>
  <LKMunMehFormRow v-else-if="item" :idx="idx" :item="item" :bold="bold" />
</template>

<script>
import LKMunMehFormRow from '@/views/LKMunMeh/Form/components/LKMunMehFormRow.vue'

export default {
  name: 'LKMunMehFormRowLink',
  components: { LKMunMehFormRow },
  props: {
    item: Object,
    idx: [String, Number],
    getLinkBuilder: Function,
    bold: Boolean,
  },
  computed: {
    routerLink() {
      return this.getLinkBuilder && this.item?.max_score > 0
    },
  },
}
</script>

<style lang="scss">
.text-right {
  text-align: end;
}

.LKMunMehForm__content__link .LKMunMehFormRow {
  padding: 0 6px;
  margin: -10px -16px;
  transition: background 0.3s ease;

  &:hover {
    background: $background-gray;
  }
}
</style>
